// 🔒 PROTECTED — PricePAL Compare — iter158 (2026-07-07)
// Dedicated registration page — separates new-user signup from `/app`.
// The registration form itself is provided by UserApp mounted in
// forceSignupMode; RegisterPage owns the marketing wrapper, the noindex
// SEO guard, and the top-of-funnel tracking events.

import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import UserApp from '../UserApp';
import { trackRegisterPageView } from '../utils/tracking';

export default function RegisterPage() {
  useEffect(() => {
    // Server-confirmed sign-up + login events fire later inside UserApp
    // after the backend returns 200. This mount event is REPORTING-ONLY.
    trackRegisterPageView();
  }, []);

  return (
    <>
      <Helmet>
        <title>Create your account — PricePAL Compare</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta
          name="description"
          content="Sign up for PricePAL Compare — the UK's smartest grocery + fuel price comparison app. 7-day free Premium trial (card required, cancel anytime) or a Standard Free plan with no card needed."
        />
        <link rel="canonical" href="https://pricepalcompare.com/register" />
      </Helmet>

      {/*
        Mount UserApp with forceSignupMode so the form defaults to signup
        (not login), disables the login toggle inside the form (the "log in
        instead" link takes the visitor to /app instead), and — on a
        successful `/api/auth/register` — redirects to /app.
      */}
      <UserApp forceSignupMode={true} redirectToAppAfterSignup={true} />
    </>
  );
}
